export default __webpack_public_path__ + "static/media/toilet-flushing.5ed452ce.mp3";